import apirecebimentoweb from '@/services/api-recebimentoweb';

let findTimeout = null;

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apirecebimentoweb.get('recebimento', { params: { ...where, ...params } }),
        apirecebimentoweb.get('recebimento/count', { params: where }),
      ]);
      return { data, total };
    },

    // CONSULTA COM CONTROLE DE CACHE
    async findWithCache({ commit, state }, { force, ttl } = {}) {
      if (!force && state.list?.length > 0) {
        return;
      }

      clearTimeout(findTimeout);

      const { data } = await apirecebimentoweb.get('recebimento');
      commit('SET_LIST', data);

      if (ttl === Infinity) return;

      findTimeout = setTimeout(() => {
        commit('SET_LIST', null);
      }, ttl ?? 1000 * 60); // TTL -> Time To Live
    },

    // CONSULTA SEM CACHE
    async findById(_, { id }) {
      const { data } = await apirecebimentoweb.get(`recebimento/${id}`);
      return data;
    },

    // async findResumo(context, { where }) {
    //   const { data } = await apirecebimentoweb.get('recebimento/resumo', { params: where });
    //   return data;
    // },

    async findResumo(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apirecebimentoweb.get('recebimento/resumo', { params: { ...where, ...params } }),
        apirecebimentoweb.get('recebimento/countresumo', { params: where }),
      ]);
      return { data, total };
    },

    async getAll(context) {
      if (context.state.currentrecebimento) {
        return context.state.currentrecebimento;
      }
      const response = await apirecebimentoweb.get('/recebimento');
      context.commit('SET_CURRENT_RECEBIMENTO', response.data);
      return response.data;
    },

    async findDistinct(_, {
      where,
    } = {}) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get('recebimento/distinct', { params: where }),
      ]);
      return { data };
    },

    async findDistinctCodigo(_, { codigo }) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get(`recebimento/distinct/${codigo}`),
      ]);
      return { data };
    },

  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },

  },
};
